import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainPageComponent } from './main-page/main-page.component';
import {MatButtonModule} from '@angular/material/button';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { PickGenderPageComponent } from './pick-gender-page/pick-gender-page.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import {NavigationDescriptionPageComponent} from "./navigation-bar/navigation-description-page.component";
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import {MatIconModule} from "@angular/material/icon";
import {MatSliderModule} from "@angular/material/slider";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatCommonModule} from '@angular/material/core';
import {CutoutRectComponent} from './shared/cutout_rect.component';
import { FinalPageComponent } from './final-page/final-page.component';
import { AboutPageComponent } from './about-page/about-page.component';

@NgModule({
  declarations: [
    AppComponent,
    MainPageComponent,
    WelcomePageComponent,
    PickGenderPageComponent,
    NavigationBarComponent,
    NavigationDescriptionPageComponent,
    AudioPlayerComponent,
    CutoutRectComponent,
    FinalPageComponent,
    AboutPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatIconModule,
    MatSliderModule,
    MatTooltipModule,
    MatCommonModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
